type Props = {
  id: string
  title: string
  autoPlay?: boolean
}

export default function VideoBox({ id, title, autoPlay = false }: Props) {
  if (!id) return null

  const base = id.startsWith('http')
    ? id.split('?')[0]
    : `https://play.gumlet.io/embed/${id}`

  return (
    <div className="video-box">
      <iframe
        src={`${base}?background=false&autoplay=${
          autoPlay ? 'true' : 'false'
        }&loop=false&disableControls=false`}
        loading="lazy"
        title={title}
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen;"
      />
    </div>
  )
}
